import type { GameModule } from '../types';
// The module's page is the ENTRY, not the table. Entry shows the lobby, then
// the join wait, and only then mounts Page — so nothing about the game exists
// (no sound, no round, no wheel) until the player has chosen a room.
import Page from './Entry';

// PORTRAIT is a deliberate decision, not a default — see docs/ROULETTE_PLAN.md:
// phones are held upright, our whole app shell (and its bottom nav) is portrait,
// the owner's reference board is portrait, and stacking "wheel above / board
// below" puts fate at the top and the player's choice under the thumb.
const roulette: GameModule = {
  id: 'roulette',
  displayName: 'Roulette',
  tag: 'Casino',
  theme: {
    gradient: 'from-emerald-700 to-red-900',
    emoji: '🎡',
    logo: '/games/roulette/Logo.png',
  },
  orientation: 'portrait',
  adminIcon: 'casino',
  adminTheme: {
    headerFrom: 'from-emerald-900',
    headerTo: 'to-red-900',
    ring: 'focus:ring-emerald-500',
    accent: 'bg-emerald-600',
    accentHover: 'hover:bg-emerald-500',
    dot: 'bg-emerald-400',
    softBg: 'bg-emerald-500/10',
    rangeAccent: 'accent-emerald-500',
    badgeClasses: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
  },
  Page,
};

export default roulette;
